import React from "react";
/* eslint-disable */
import {
    Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table , Grid
} from '@material-ui/core';
import moment from "moment";
export default class ComponentToPrint extends React.Component {

    render() {
        const gtnWiseSummaryDetails = this.props.gtnWiseSummaryDetails;
        const data = this.props.searchData;
        const totalValue = this.props.totalValue;
        const totalValues = this.props.totalValues
        return (
            <div align='left'>
                <h3><center><u>FDC Inbound Transactions Report</u></center></h3>
                <div >&nbsp;</div>
                <div>&nbsp;</div>
                <Box minWidth={1150}>

                    <TableContainer>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left">GTN No</TableCell>
                                    <TableCell align="left">Lorry Number</TableCell>
                                    <TableCell align="left">SKU Code</TableCell>
                                    <TableCell align="left">SKU Name</TableCell>
                                    <TableCell align="left">GRN Date</TableCell>
                                    <TableCell align="left">FCC Code</TableCell>
                                    <TableCell align="left">FCC Name</TableCell>
                                    <TableCell align="right">Quantity</TableCell>
                                    <TableCell align="right">Value(LKR)</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {gtnWiseSummaryDetails.map((row) => (
                                    <TableRow key={`${row.grnNumber || row.GrnNumber || 'NA'}-${row.skuCode || row.productCode || row.productCodeCode}-${row.factoryID}`}>
                                    <TableCell align="left">
                                        {row.grnNumber || row.GrnNumber || '-'}
                                    </TableCell>
                                    <TableCell align="left">
                                        {row.lorryNumber}
                                    </TableCell>
                                    <TableCell align="left">
                                        {row.skuCode || row.productCode || row.productCodeCode || '-'}
                                    </TableCell>
                                    <TableCell align="left">
                                        {row.skuName || row.productName || '-'}
                                    </TableCell>
                                     <TableCell align="left">
                                        {moment(new Date(row.grnDate)).format('YYYY-MM-DD')}
                                    </TableCell>
                                    <TableCell align="left">
                                        {row.factoryCode}
                                    </TableCell>
                                    <TableCell align="left">
                                        {row.factoryName}
                                    </TableCell>
                                    <TableCell align="right">
                                        {parseFloat(row.quantity).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </TableCell>
                                    <TableCell align="right">
                                        {parseFloat(row.totalValue).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                    </TableCell>
                                </TableRow>
                                ))}
                                <TableRow>
                                    <TableCell sx={{ fontWeight: "bold" }} align="left" colSpan={8}>
                                        Total
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: "bold" }} align="right">{parseFloat(totalValue).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Grid container spacing={3} style ={{ marginLeft: '10px',marginTop: '10px' }}>
                        <Grid item md={6} xs={12}>
                        <b> KG Quantity Total </b> : {totalValues.kgQuantityTotal == 0 || totalValues.kgQuantityTotal == undefined? '-' : parseFloat(totalValues.kgQuantityTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </Grid>
                        <Grid item md={6} xs={12}>
                        <b> UNIT Quantity Total </b> : {totalValues.unitQuantityTotal == 0 || totalValues.unitQuantityTotal == undefined ? '-' : parseFloat(totalValues.unitQuantityTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </Grid>
                    </Grid>
                </Box>
            </div>

        );
    }
}
